export default __webpack_public_path__ + "static/media/contractDeleteIcon.3a1ed204.svg";